import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { Dashboard } from './pages/Dashboard';
import { Login } from './pages/Login';
import { NotFound } from './pages/NotFound';
import { Register } from './pages/Register';
import { Activate } from './pages/activation/Activate';
import { ActivationHistory } from './pages/activation/ActivationHistory';
import { AchievementRewards } from './pages/income/AchievementRewards';
import { AlphaClubA } from './pages/income/AlphaClubA';
import { AlphaClubB } from './pages/income/AlphaClubB';
import { EliteRank } from './pages/income/EliteRank';
import { IncomeLedger } from './pages/income/IncomeLedger';
import { LevelIncome } from './pages/income/LevelIncome';
import { Profile } from './pages/profile/Profile';
import { Security } from './pages/profile/Security';
import { WalletStatus } from './pages/profile/WalletStatus';
import { RankAchievement } from './pages/rank/RankAchievement';
import { CreateTicket } from './pages/support/CreateTicket';
import { TicketDetail } from './pages/support/TicketDetail';
import { TicketList } from './pages/support/TicketList';
import { BinaryTree } from './pages/team/BinaryTree';
import { DirectTeam } from './pages/team/DirectTeam';
import { LevelTeam } from './pages/team/LevelTeam';
import { ReferralList } from './pages/team/ReferralList';
import { BuyLds1 } from './pages/wallet/BuyLds1';
import { Deposit } from './pages/wallet/Deposit';
import { Transactions } from './pages/wallet/Transactions';
import { Transfer } from './pages/wallet/Transfer';
import { Withdrawal } from './pages/wallet/Withdrawal';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      <Route element={<AppShell />}>
        <Route index element={<Dashboard />} />

        {/* Profile */}
        <Route path="profile" element={<Profile />} />
        <Route path="security" element={<Security />} />
        <Route path="wallet-status" element={<WalletStatus />} />

        {/* Package */}
        <Route path="activation" element={<Activate />} />
        <Route path="activation/history" element={<ActivationHistory />} />

        {/* Income — the six Alpha One types plus achievement rewards.
            Tier/progress screens get bespoke pages; the flat ledgers share one. */}
        <Route path="income">
          <Route index element={<Navigate to="/income/direct-referral" replace />} />
          <Route path="level-income" element={<LevelIncome />} />
          <Route path="alpha-club-a" element={<AlphaClubA />} />
          <Route path="alpha-club-b" element={<AlphaClubB />} />
          <Route path="elite-rank" element={<EliteRank />} />
          <Route path="achievement-rewards" element={<AchievementRewards />} />
          <Route path=":type" element={<IncomeLedger />} />
        </Route>

        {/* Team */}
        <Route path="team">
          <Route index element={<Navigate to="/team/direct" replace />} />
          <Route path="direct" element={<DirectTeam />} />
          <Route path="level" element={<LevelTeam />} />
          <Route path="referral-list" element={<ReferralList />} />
          <Route path="binary" element={<BinaryTree />} />
        </Route>

        {/* Wallet */}
        <Route path="wallet">
          <Route index element={<Navigate to="/wallet/transactions" replace />} />
          <Route path="deposit" element={<Deposit />} />
          <Route path="withdrawal" element={<Withdrawal />} />
          <Route path="transfer" element={<Transfer />} />
          <Route path="buy-lds1" element={<BuyLds1 />} />
          <Route path="transactions" element={<Transactions />} />
        </Route>

        <Route path="rank" element={<RankAchievement />} />

        {/* Support */}
        <Route path="support">
          <Route index element={<Navigate to="/support/list" replace />} />
          <Route path="create" element={<CreateTicket />} />
          <Route path="list" element={<TicketList />} />
          <Route path="view/:id" element={<TicketDetail />} />
        </Route>
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
